function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { VuetifyWidgetModel } from './VuetifyWidget';
export class ColModel extends VuetifyWidgetModel {
  defaults() {
    return _objectSpread({}, super.defaults(), {
      _model_name: 'ColModel',
      align_self: null,
      cols: undefined,
      lg: undefined,
      md: undefined,
      offset: undefined,
      offset_lg: undefined,
      offset_md: undefined,
      offset_sm: undefined,
      offset_xl: undefined,
      order: undefined,
      order_lg: undefined,
      order_md: undefined,
      order_sm: undefined,
      order_xl: undefined,
      sm: undefined,
      tag: null,
      xl: undefined
    });
  }

  getVueTag() {
    // eslint-disable-line class-methods-use-this
    return 'v-col';
  }

}
ColModel.serializers = _objectSpread({}, VuetifyWidgetModel.serializers);